import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: 'https://kodeal.fks.co.kr/api',
  withCredentials: true,
});
